exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title[data-v-2fa87b2b] {\n    display: block;\n    font-size: .60em;\n    padding: 0;\n    margin: 0;\n}\n.chart-description[data-v-2fa87b2b] {\n    font-size: .95em;\n}\n", ""]);

// exports
